<template>
  <v-container class="pa-0 ma-0" id="mainhomecontainer">
    <v-card class="overview" elevation="0">
      <v-card-title class="pa-0">
        <v-container style="min-height:200px;" class="topbg">
          <v-row>
            <v-col
              cols="12"
              md="12"
              color="white--text"
              class="text-center mt-5 mb-5"
              style="color:#fff;"
            >
              Welcome to Juzzap
              <br />
              <span class style="font-size:16px;">A NEW PARADIGM</span>
            </v-col>
          </v-row>
        </v-container>

        <v-row class="pwa-content">
          <v-col cols="12" md="12" class="text-center">
            <img :src="juzzapLogo" width="100" />
          </v-col>
        </v-row>

        
      </v-card-title>

      <v-card-text class="mb-auto pa-0">
        <v-container fluid>
          <v-row>
            <v-col cols="12" md="12" sm="12" class="text-center">
              <h2>{{storeUser.name}}</h2>
            </v-col>

            <v-col cols="12" md="12" sm="12" class="text-center" v-if="isloggedin">
                <v-btn color="error" text @click="logout">Logout</v-btn>
            </v-col>

            
           
          </v-row>

          <v-row>

              <v-col cols="12" md="12">
                  Businesses you visited in last 21 days.
              </v-col>
          </v-row>  

          <v-row >
              <v-col cols="8" md="8">
                  <strong>Business</strong>
              </v-col>
              <v-col cols="4" md="4">
                  <strong>Visited On</strong>
              </v-col>
          </v-row>

          <v-row v-for="visited in visitedBusiness">
              <v-col cols="8" md="8">
                  {{visited.businessname}}<br>{{visited.biz_address}}
              </v-col>
              <v-col cols="4" md="4">
                  {{visited.visitdatetime}}
                  
              </v-col>
          </v-row>

          

          
          

          
        </v-container>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import Vue from "vue";
import moment from "moment";
export default {
  props: {
    source: String
  },
  data: () => ({
    codeError: false,
    businesscode2: "",
    businesscode1: "",
    businesscode3: "",
    juzzapLogo: require("@/assets/logo-Copy.png"),
    editIcon: require("@/assets/edit.png"),
    foodIcon: require("@/assets/dish.png"),
    drinkIcon:require("@/assets/drink.png"),
    valid: false,
    code: "",
    key: "",
    bannerImg: require("@/assets/overview-banner.jpg"),
    address: "",
    loading: false,
    visitedBusiness: [],
    

    dictionary: {
      attributes: {
        permited_internal_capacity: "Permited internal capacity",
        permited_external_capacity: "Permited external capacity",
        email: "E-mail Address",
        businessName: "Business Name",
        businessType: "Business Type",
        confirmation: "Confirm your full acceptgance"
      },
      custom: {},
      isloggedin:false,
    },
    
  }),
  created() {
    //    if (this.$route.params.key) {
    //   this.key = this.$route.params.key;
    //    }


    this.storeUser = JSON.parse(localStorage.getItem("user"));
    if(localStorage.getItem('isLoggedin')=='true')
    {
        this.isloggedin=true;
    }else{
        this.isloggedin=false;
    }
     this.getvisitedBusiness();
    
  },
  methods: {
    editbusinessprofile() {
      //this.storeBusiness=JSON.parse(this.$store.getters.business);

      this.$router.push({
        name: "updatebusiness",
        params: { id: this.storeBusiness.id }
      });
    },

    foodmenu() {
      this.$router.push({
        name: "businessfoodlist",
        params: { id: this.storeBusiness.id }
      });
    },

    drinkmenu() {
      //this.$router.push({name:'businessdrinklist',params:{id:this.storeBusiness.id}});
    },

    getCookie(cname) 
    {
                var name = cname + "=";
                var decodedCookie = decodeURIComponent(document.cookie);
                var ca = decodedCookie.split(';');
                for(var i = 0; i <ca.length; i++) {
                    var c = ca[i];
                    while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                    }
                    if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                    }
                }
                return "";
    },

    getvisitedBusiness()
    {    
      let url=this.$apidomain+"getvisitedlist";
      if(this.getCookie('jzuserkey')!=''){
        url=this.$apidomain+"getvisitedlist/"+this.getCookie('jzuserkey');
      }
        this.$http
        .get(
          url
        )
        .then(res => {
          if (res.data.success) {
            this.visitedBusiness = res.data.visitedlist;
            
          }
        })
        .catch(err => {
          console.log(err.response);
        });
    },
    

    
    
   
    logout() {
      this.$store.dispatch("logout").then(() => {
        this.$router.push("/");
      });
    }
  }
};
</script>
<style scoped>
.p-10 {
  padding: 10px;
}
.pwa-content {
  margin-top: -63px;
}
#mainhomecontainer.container {
  width: 100%;
  max-width: 100%;
}
#mainhomecontainer.container .heading {
  color: #fff;
}
.topbg {
  background: #fe5800;
}
</style>